import { render, staticRenderFns } from "./ModalPreencherDadosComercial.vue?vue&type=template&id=6aae245c&scoped=true"
import script from "./ModalPreencherDadosComercial.vue?vue&type=script&setup=true&lang=js"
export * from "./ModalPreencherDadosComercial.vue?vue&type=script&setup=true&lang=js"
import style0 from "./ModalPreencherDadosComercial.vue?vue&type=style&index=0&id=6aae245c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6aae245c",
  null
  
)

export default component.exports